{{ call.date | date: 'd MMM y' }} •
{{ call.date | date: 'HH:mm' }}
@if (call.duration !== null) {
  • {{ call.duration | duration }}
}
@if (!call.isUpcoming && !call.isOngoing) {
  <span class="expiry-badge" [class.urgent]="isExpiryUrgent" [matTooltip]="getExpiryTooltip()">
    {{ getExpiryText() }}
  </span>
  @if (templateItems.length > 0) {
    <app-meeting-health-indicator [userActionsItems]="getMeetingHealthItems()" [avgConfidenceScore]="call.avgConfidenceScore"> </app-meeting-health-indicator>
  }
}
@if (call.callSetIndex !== null && call.callSetSize !== null && call.callSetSize > 1) {
  <span class="part-badge" [matTooltip]="'CALLS.PART_BADGE_TOOLTIP' | translate: { index: call.callSetIndex + 1, total: call.callSetSize }">
    {{ 'CALLS.PART_BADGE_TEXT' | translate: { index: call.callSetIndex + 1, total: call.callSetSize } }}
  </span>
}
@if (call.processingStatus) {
  <mat-chip>{{ 'CALLS.PROCESSING_STATUSES.' + call.processingStatus | translate }}</mat-chip>
}
